import SMFindBankAccount from '../../containers/FindBankAccount'
export const FindBankAccountScreen: React.FC = () => {
    // ======================= VIEWS
    return (
        <>
            <SMFindBankAccount />
        </>
    )
}

// ======================= EXPORT
export default FindBankAccountScreen
